import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import CertificateWithAwardRibbon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/CertificateWithAwardRibbon';
import HeartWithCross from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/HeartWithCross';
import TwoPapersWithDollarSign from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPapersWithDollarSign';
// styles
import { ColStyled } from './styles';

export default () => (
  <SectionContainer
    id='non-qualified-retirement-plan-product-callout-grouping-2'
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Typography
          align='center'
          component='h2'
          variant='h4'
          nextElement='graphic'>
          Other selective executive <WidowBlock>non&#45;qualified plans:</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='left'>
      <ColStyled
        medium={6}
        large={4}>
        <ProductCard
          cardId='product-callout-non-qualified-retirement-plan-executive-bonus-plan'
          icon={CertificateWithAwardRibbon}
          backgroundVariant='lightA'
          cardHeading='Executive Bonus Plan'
          cardText={
            <>
              This lets an employer or business owner take out, and pay for, a&nbsp;
              <Link
                id='product-callout-non-qualified-retirement-plan-permanent-life-insurance'
                variant='primaryDeemphasize'
                linkUrl='/life-insurance/permanent-life-insurance/'>
                permanent life insurance
              </Link>
              &nbsp;policy for a key employee. The policy&#39;s cash value grows tax deferred and can be used as extra retirement income.
            </>
          }
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={4}>
        <ProductCard
          cardId='product-callout-non-qualified-retirement-plan-split-dollar-plan'
          icon={TwoPapersWithDollarSign}
          backgroundVariant='lightA'
          cardHeading='Split Dollar Plan'
          cardText={
            <>
              Created by an employer and a key employee, both parties agree to share the ownership, costs, cash value, and death benefit of a permanent life insurance policy, like&nbsp;
              <Link
                id='product-callout-non-qualified-retirement-plan-whole-life-insurance'
                variant='primaryDeemphasize'
                linkUrl='/life-insurance/whole-life-insurance/'>
                whole life
              </Link>.
            </>
          }
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={4}
        disableBottomMargin>
        <ProductCard
          cardId='product-callout-non-qualified-retirement-plan-wage-continuation'
          icon={HeartWithCross}
          backgroundVariant='lightA'
          cardHeading={<>Disability Wage <WidowBlock>Continuation plan</WidowBlock></>}
          cardText={
            <>
              This benefit is designed to replace part or all of a key employee&#39;s income (while using the tax code to their advantage) if they&#39;re not able to work due to sickness or injury.
            </>
          }
        />
      </ColStyled>
    </Row>
  </SectionContainer>
);
